module.exports = __webpack_public_path__ + "73958b3dbd2cef0536a50982a365ec98.svg";